<template>
  <up-card>
    <button
      v-if="markable"
      @click.stop.prevent="markParticipant"
      :aria-label="$t(marked ? 'participantList.unmark' : 'participantList.mark')"
      class="mark-participant"
    >
      <i :class="[marked ? 'exu-bookmark-check-fill' : 'exu-bookmark']"/>
    </button>
    <div class="photo__wrapper">
      <div class="photo-status__wrapper">
        <div
          v-if="photo"
          class="photo-item"
        >
          <img
            :src="photo"
            alt=""
          >
        </div>
        <div
          v-else
          :class="photoAlter"
          class="photo-item alter-photo"
        >
          <div>
            {{ firstLetter }}
          </div>
        </div>
        <div v-if="visitStatus"
          :class="visitStatus"
          class="photo-status"
        />
      </div>
    </div>
    <div class="data__wrapper">
      <p class="primary-data">{{ name }}</p>
      <p class="secondary-data mb-1">{{ visiblePosition }}</p>
      <p class="secondary-data">{{ company }}</p>
    </div>
    <template v-slot:stretch-link>
      <router-link
        :to="link"
        class="stretch-link"
      />
    </template>
  </up-card>
</template>

<script>
export default {
  name: 'ParticipantCard',
  props: {
    id: {
      requared: true,
    },
    photo: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    lastVisit: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    fullProp: {
      type: Object,
      default: () => ({}),
    },
    // закладка есть только у авторизованного: избранное хранится за учётной записью
    markable: {
      type: Boolean,
      default: false,
    },
    marked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['marking'],
  methods: {
    markParticipant() {
      this.$emit('marking', this.id);
    },
  },
  computed: {
    visiblePosition() {
      return `${this.position.substring(0, 42)}${this.position.length > 42 ? '...' : ''}`;
    },
    link() {
      return `/participant/profile/${this.id}`;
    },
    photoAlter() {
      return ['rose', 'orange', 'blue', 'purpure', 'lilac', 'green'][Math.floor(Math.random() * 6)];
    },
    firstLetter() {
      if (this.fullProp.fname && this.fullProp.lname) {
        const [name, lastname] = [this.fullProp.fname.trim(), this.fullProp.lname.trim()];
        return `${lastname[0]}${name[0]}`;
      }
      // eslint-disable-next-line no-unused-vars
      const [name, lastname, ...rest] = this.name.toUpperCase().split(' ');
      return `${lastname[0]}${name[0]}`;
    },
    visitStatus() {
      const TYPE_STATUS = ['never', 'several', 'today'];
      return this.lastVisit && TYPE_STATUS.includes(this.lastVisit) ? this.lastVisit : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

// поверх растянутой ссылки карточки, иначе нажатие уходит в профиль
.mark-participant {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  padding: 0;
  border: none;
  background-color: transparent;
  color: $color-accent;
  font-size: 20px;
  line-height: 20px;
}
.photo__wrapper {
  .photo-status {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    &.never {
      background: radial-gradient(#95969D 40%, transparent 100%);
    }
    &.several {
      background: radial-gradient(#F0D040 40%, transparent 100%);
    }
    &.today {
      background: radial-gradient(#40F040 40%, transparent 100%);
    }
    &__wrapper {
      position: relative;
      width: 64px;
      height: 64px;
      margin: 0 auto;
    }
  }
  .photo-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    margin: 0 auto;
    border-radius: 50%;
    overflow: hidden;
    // temp style
    // background: #0D0D26;
    border: 1px solid #F5F5F3;
    &.alter-photo {
      font-size: 16px;
      font-weight: 500;
      color: #FFFEFB;
    }
    &.rose {
      background: #B4542B;
    }
    &.orange {
      background: #8C6239;
    }
    &.blue {
      background: #4E6480;
    }
    &.purpure {
      background: #6E4F63;
    }
    &.lilac {
      background: #5C6B52;
    }
    &.green {
      background: #3E6B6B;
    }

    & > img {
      max-width: 100%;
      // max-height: 100%;
    }
  }
}
.data__wrapper {
  text-align: center;
  font-size: 12px;
  p {
    margin: 0;
    line-height: 1.3em;
    &.primary-data {
      font-weight: bold;
      color: #0D0D26;
    }
    &.secondary-data {
      color: #AFB0B6;
      color: #95969D;
    }
  }
}
.stretch-link {
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
</style>
